<div id="map" [style]="'width: ' + width + 'px; height: ' + height + 'px;'"></div>
